import type { ComponentTheme } from '../types/component-theme';

export default {
    slots: {
        content: 'flex flex-col sm:flex-row',
        rangeColumn: 'mb-2 sm:flex sm:items-center sm:mb-0',
        rangeGrid: 'grid grid-cols-2 gap-1 sm:grid-cols-1',
        rangeButton:
            'text-(--text-light)! hover:bg-(image:--surface-select-bg)! hover:text-(--text-dark)! ' +
            'hover:shadow-(--surface-select-shadow)! aria-pressed:bg-(image:--surface-select-item-active-bg)! ' +
            'aria-pressed:text-(--input-neumorphic-text)! aria-pressed:shadow-(--surface-select-item-active-shadow)!',
        clearButton: 'text-(--text-light)! hover:text-(--text-dark)!',
        actions: 'mt-2 flex justify-end',
        actionButton:
            'border border-(--neutral-border-soft)! ring-0! bg-transparent! text-(--input-neumorphic-text)! ' +
            'shadow-(--surface-select-shadow)! hover:bg-transparent! hover:bg-(image:--surface-select-bg)! ' +
            'hover:shadow-(--surface-select-item-active-shadow)! active:bg-transparent! ' +
            'active:bg-(image:--surface-select-item-active-bg)!'
    },
    variants: {
        hasRanges: {
            true: {
                content: 'sm:divide-x sm:divide-(--slate-muted-alpha-20)',
                rangeColumn: 'sm:pe-2 sm:me-2'
            }
        }
    }
} satisfies ComponentTheme;
